<template lang="pug">
.generic-wrapper
  .container
    BackButton(name="CMSOverview")
    h1.title Angebote
    .sub-headline Hier können Sie alle Angebote verwalten.
    
    .button-wrapper.margin-top      
      b-button(type="is-light" icon-left="plus" @click="$router.push({name: 'CMSPromotionNew'})") Neues Angebot anlegen

    .card.margin-top
      .main
        b-table(:data="promotions"
                default-sort-direction="asc"
                default-sort="date"
                hoverable
                @click="row => $router.push({ name: 'CMSPromotionEdit', params: { id: row.id } })")
          b-table-column(field='name' label='Name' sortable, v-slot="props")
            | {{props.row.name}}
          b-table-column(label='Zeit' v-slot="props")
            | {{formatDate(props.row.startDate)}} - {{formatDate(props.row.endDate)}}
          b-table-column(label='Min. Nächte' v-slot="props")
            | {{props.row.minNights}}
          b-table-column(label='Angebot' sortable, v-slot="props")
            div(v-if="props.row.freeNights")
              | {{props.row.freeNights}} gratis Nächte
            div(v-else-if="props.row.discountPercentage")
              | {{props.row.discountPercentage}}% Rabatt
            div(v-else) ***FEHLER***
          b-table-column(label='Super Fair Mode' v-slot="props")
            | {{props.row.isFairMode ? 'Ja' : 'Nein'}}
          b-table-column(v-slot="props")
            div
              b-tooltip(label='Bearbeiten' type='is-secondary' position='is-bottom' :delay="1250")
                b-button(icon-right="pencil", type="is-secondary" @click="$router.push({ name: 'CMSPromotionEdit', params: { id: props.row.id } })")
              .spacer.sm.inline
              b-tooltip(label='Dauerhaft löschen' type='is-danger' position='is-bottom' :delay="1250")
                b-button(icon-right="close", type="is-danger" @click="deletePromotion(props.row)")
</template>

<script>
import { DateTime } from 'luxon';

export default {
  data() {
    return {
    };
  },
  computed: {
    promotions() {
      return this.$store.state.promotions.all;
    },
  },
  methods: {
    deletePromotion(row) {
      this.$buefy.dialog.confirm({
        title: "Angebot löschen",
        message: `Sind Sie sicher, dass Sie dieses Angebot <b>${row.name}</b> löschen möchten? Diese Aktion kann nicht rückgängig gemacht werden.`,
        confirmText: "Angebot löschen",
        cancelText: "Abbrechen",
        type: "is-danger",
        hasIcon: true,
        onConfirm: async () => {
          try {
            await this.$store.dispatch("promotions/delete", { id: row.id });
            this.$buefy.toast.open("Angebot gelöscht!");
          } catch (e) {
            this.$store.dispatch(
              "common/showError",
              "Angebot konnte nicht gelöscht werden."
            );
          }
        }
      });
    },
    formatDate(d) {
      const dt = DateTime.fromISO(d);
      return dt.setLocale('de')
        .toFormat("dd. LLL. yy")
    }
  },
  mounted() {
    this.$store.dispatch("promotions/findAll");
  }
};
</script>

<style lang="scss" scoped>
.icon-name {
  margin-left: $sm-space;
}
</style>